import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { IconProp } from '@fortawesome/fontawesome-svg-core';

import { PopupMetadata, PopupType } from '../../core/constants';

@Injectable({
  providedIn: 'root',
})
export class ObjectPickerDialogMetadataService {
  constructor(private translateService: TranslateService) {}

  private readonly metadataMap: Record<PopupType, PopupMetadata> = {
    // ! Feed and Dimension - mixed for Editing and Creating events:
    // ! CREATE_FEED - not used -> CREATE_DIMENSION

    [PopupType.SELECT_USERS]: {
      action: 'popup.action-title.select-users',
      actionIcon: ['fas', 'user-plus'],
      popupType: PopupType.SELECT_USERS,
    },
    [PopupType.ADD_PRINCIPALS]: {
      action: 'popup.action-title.add-principals',
      actionIcon: ['fas', 'user-plus'],
      popupType: PopupType.ADD_PRINCIPALS,
    },
    [PopupType.SELECT_NEW_OWNER]: {
      action: 'popup.action-title.select-new-owner',
      actionIcon: ['fas', 'user-plus'],
      popupType: PopupType.SELECT_NEW_OWNER,
    },
    [PopupType.SELECT_PRINCIPALS]: {
      action: 'popup.action-title.select-principals',
      actionIcon: ['fas', 'user-plus'],
      popupType: PopupType.SELECT_PRINCIPALS,
    },
    [PopupType.SELECT_DATASOURCES]: {
      action: 'popup.action-title.select-datasources',
      actionIcon: ['fas', 'search-plus'],
      popupType: PopupType.SELECT_DATASOURCES,
    },
    [PopupType.SELECT_FAVORITE_DIMENSIONS]: {
      action: 'popup.action-title.select-favorite-dimensions',
      actionIcon: ['fas', 'link'],
      popupType: PopupType.SELECT_FAVORITE_DIMENSIONS,
    },
    [PopupType.ATTACH_DIMENSIONS_AS_PIVOTS]: {
      action: 'popup.action-title.attach-dimensions-as-pivots',
      actionIcon: ['fas', 'link'],
      popupType: PopupType.ATTACH_DIMENSIONS_AS_PIVOTS,
    },
    [PopupType.ATTACH_DIMENSIONS_AS_FILTERS]: {
      action: 'popup.action-title.attach-dimensions-as-filters',
      actionIcon: ['fas', 'link'],
      popupType: PopupType.ATTACH_DIMENSIONS_AS_FILTERS,
    },
    [PopupType.ATTACH_FILTERS]: {
      action: 'popup.action-title.attach-filters',
      actionIcon: ['fas', 'filter'],
      popupType: PopupType.ATTACH_FILTERS,
    },
  };

  getPopupMetadata(type: PopupType): PopupMetadata | null {
    return this.metadataMap[type] ?? null;
  }

  getActionText(metadata: PopupMetadata): string {
    if (!metadata) return '';
    return this.translateService.instant(metadata.action);
  }
  getActionIcon(metadata: PopupMetadata): IconProp {
    if (!metadata) return null;
    return metadata.actionIcon;
  }
}
